import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import * as PXBColors from '@brightlayer-ui/colors';

const locationStyles = makeStyles(() =>
    createStyles({
        serachDiv: {
            backgroundColor: 'white',
        },
        addIcon: {
            height: 30,
            width: 30,
            margin:'0px 5px'
        },
        iconRightEnd: {
            display: 'flex',
            flex: 1,
            justifyContent: 'flex-end',
        },
        margin8: { margin: 8 },
        addButton: {
            display: 'flex',
            justifyContent: 'space-between',
            paddingTop: 32,
            padding:8
        },
        wordWrap: {
            wordBreak: 'break-all',
            wordWrap: 'break-word',
            whiteSpace: 'pre-wrap',

        },
        transparentHover: {
            '&:hover': {
                backgroundColor: 'transparent',
                borderColor: 'transparent',
                boxShadow: 'none',
            },
        },
        wrapText: {
            lineHeight: 1.25,
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 1,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            fontWeight: 600,
        },
        avatar: {
            backgroundColor: PXBColors.blue[400],
            color: PXBColors.white[500],
        },
        titleFontWeight: {
            fontWeight: 600,
            lineHeight: 1,
        },
        subTitleFontWeight: {
            fontWeight: 400,
        },
        padding4: {
            padding: 4
        },
        padding8: {
            padding: 8
        },
        padding16: {
            padding: 16
        },
        paddingTop16: {
            paddingTop: 16
        },
        paddingTop8: {
            paddingTop: 8
        },
        paddingTop0: {
            paddingTop: 0
        },
        paddingBottom24: {
            paddingBottom: 24
        },
        paddingLeft32: {
            paddingLeft: 32
        },
        paddingTextbox: {
            padding: '16px 8px'
        },
        iconPosition: {
            marginTop: 24, marginRight: 24
        },
        flexRow: {
            display: 'flex', flexDirection: 'row'
        },
        flexContentEnd: {
            display: 'flex', justifyContent: 'flex-end'
        }
    })
);

export default locationStyles;
